export default "__VITE_ASSET__$R3HtyGo__"